import { useState } from "react";
import {
  Icon,
  KeyValueList,
  RenderWhen
} from "../../../../../../../components";
import { StringWithCopy } from "../../common";
import { PDFExport } from "../../../@types/PDFExport";

type Props = {
  sha1: string;
  sha256: string;
  sha512: string;
  md5: string;
  imphash: string | null;
  ssdeep: string | null;
  tlsh: string | null;
} & PDFExport;

const Hashes = ({
  sha1,
  sha256,
  sha512,
  md5,
  imphash,
  ssdeep,
  tlsh,
  isPdfView
}: Partial<Props>) => {
  const [isExpanded, setIsExpanded] = useState(isPdfView || false);

  const toggleExpanded = () => {
    setIsExpanded(prev => !prev);
  };

  return (
    <div
      className="flex flex-column flex-gap-2 width-100-pc"
      data-testid="report_summary_hashes"
    >
      <div className="flex flex-gap-2">
        <KeyValueList.Item
          className="flex"
          keyClassName="white-space-nowrap"
          label="SHA1:"
          value={<StringWithCopy value={sha1} />}
          data-testid="report_summary_hashes_sha1"
        />
        <RenderWhen condition={!isPdfView}>
          <div
            className="flex flex-gap-2 cursor-pointer"
            onClick={toggleExpanded}
            data-testid="report_summary_hashes_toggle"
          >
            <span className="underline">
              See {isExpanded ? "Fewer" : "More"} Hashes
            </span>
            <Icon name={isExpanded ? "chevron-up" : "chevron-down"} />
          </div>
        </RenderWhen>
      </div>
      <RenderWhen condition={isExpanded}>
        <KeyValueList.Item
          className="flex"
          keyClassName="white-space-nowrap"
          label="SHA256:"
          value={<StringWithCopy value={sha256} />}
          data-testid="report_summary_hashes_sha256"
        />
        <KeyValueList.Item
          className="flex"
          keyClassName="white-space-nowrap"
          label="MD5:"
          value={<StringWithCopy value={md5} />}
          data-testid="report_summary_hashes_md5"
        />
        <KeyValueList.Item
          className="flex"
          keyClassName="white-space-nowrap"
          label="IMPHASH:"
          value={<StringWithCopy value={imphash} />}
          data-testid="report_summary_hashes_imphash"
        />
        <KeyValueList.Item
          className="flex"
          keyClassName="white-space-nowrap"
          label="SHA512:"
          value={<StringWithCopy value={sha512} />}
          data-testid="report_summary_hashes_sha512"
        />
        <KeyValueList.Item
          className="flex"
          keyClassName="white-space-nowrap"
          label="SSDEEP:"
          value={<StringWithCopy value={ssdeep} />}
          data-testid="report_summary_hashes_ssdeep"
        />
        <KeyValueList.Item
          className="flex"
          keyClassName="white-space-nowrap"
          label="TLSH:"
          value={<StringWithCopy value={tlsh} />}
          data-testid="report_summary_hashes_tlsh"
        />
      </RenderWhen>
    </div>
  );
};

export default Hashes;
